export const GET_IMPORT_PENDING = "GET_IMPORT_PENDING";
export const GET_MORE_IMPORT_PENDING = "GET_MORE_IMPORT_PENDING";
export const GET_IMPORT_SUCCESS = "GET_IMPORT_SUCCESS";
export const GET_MORE_IMPORT_SUCCESS = "GET_MORE_IMPORT_SUCCESS";
export const RESET_IMPORT = "RESET_IMPORT";
